import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-labeled-action-button',
    templateUrl: './labeled-action-button.component.html',
    styleUrls: ['./labeled-action-button.component.scss']
})
export class LabeledActionButtonComponent implements OnInit {

    @Input()
    isDisabled: boolean;

    @Input()
    action: any;

    @Input()
    label: string;

    @Input()
    hint: string;

    @Input()
    icon: string;

    constructor() { }

    ngOnInit() {
    }

}
